import { Component, OnInit } from '@angular/core';
import {CultureModel} from '../../../models/localization-and-pricing/culture.model';
import {Router} from '@angular/router';
import {CountryModel} from '../../../models/localization-and-pricing/country.model';
import {StringExtensionModel} from '../../../models/extensions/string-extension.model';
import {NavigationModel} from '../../../models/localization-and-pricing/navigation.model';

@Component({
  selector: 'app-evo-land-choose-language',
  templateUrl: './evo-land-choose-language.component.html',
  styleUrls: ['./evo-land-choose-language.component.css']
})
export class EvoLandChooseLanguageComponent implements OnInit {

  list = CultureModel.dropdownList();

  constructor(private router: Router) { }

  ngOnInit() {

    // Has previously selected a default country
    if (CultureModel.getHomepageCulture() && CountryModel.getHomepageCountry()) {

      this.router.navigate(NavigationModel.getHomeURLPaths(['landing']));

    }

  }

  onLanguageSelected(culture: string) {

    let country = CountryModel.getHomepageCountry();
    if (!country) {
      country = CountryModel.GBR;
    }

    this.router.navigate(['home', country, culture, 'landing']);

  }

}
